import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=508462ee&scoped=true"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=508462ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508462ee",
  null
  
)

export default component.exports